var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapContent"},[_c('div',{staticClass:"ChinaMap"},[_c('dv-flyline-chart-enhanced',{staticStyle:{"width":"100%","height":"100%"},attrs:{"dev":true,"config":_vm.mapConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }